import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus' // element-plus 组件
import 'element-plus/dist/index.css'// element-plus 样式
import '@/assets/style/index.scss' // 引入自定义样式
import filters from '@/filters/index' // 过滤器
import vue3SeamlessScroll from 'vue3-seamless-scroll' // 滚动
// 将自动注册所有组件为全局组件
import dataV from '@jiaminghi/data-view'

const app = createApp(App)

app.config.productionTip = false

app.config.globalProperties.$filters = filters

app
  .use(store)
  .use(router)
  .use(ElementPlus)
  .use(vue3SeamlessScroll)
  .use(dataV)
  .mount('#app')
